/**
 * Available antenna kill operations
 *
 * @namespace tmrAntennaKillOperations
 * @type {ngConstant}
 * @see Antenna
 */
export const constant = ['tmrAntennaKillOperations', {}]
